import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router, Routes, RouterModule } from '@angular/router';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { InternationalPhoneNumberModule } from 'ngx-international-phone-number';
@Component({
  selector: 'app-woohoo-landing',
  templateUrl: './woohoo-landing.component.html',
  styleUrls: ['./woohoo-landing.component.scss']
})
export class WoohooLandingComponent implements OnInit {
  profileData: any=[];
  profileID = '';
  landing: boolean = true;
  signup: boolean = false;
  newUserStatus = '';
  errorAlert: boolean = false;
  constructor(public ngxSmartModalService: NgxSmartModalService, private route: ActivatedRoute, public http: HttpClient, private router: Router) {this.currency(), this.operator()}
  loaded:boolean = false;
  currencyType: any[];
  operatorType: any[];
  name:string = '';
  mobNum:string = '';
  email:string = '';
  countrycode: any;
  password:string = '';
  currencyChoice:string = ''; //set for Nigerian Naira!
  mobOperatorChoice:string = ''; //set for MTN Nigeria
  preferredCountries = [
    {"country":"South Africa", "code":'za', "dialcode":"+27"},
    {"country":"Nigeria", "code":'ng', "dialcode":"+97"},
    {"country":"Tunisia", "code":'tu', "dialcode":"+22"},
    {"country":"Egypt", "code":'eg', "dialcode":"+20"}
  ];
 onMobNumKeyUp(event:any){
    this.mobNum = event.target.value;
  }
  onNameKeyUp(event:any){
    this.name = event.target.value;
 
  }
  onEmailKeyUp(event:any){
    this.email = event.target.value;
   
  }
  onPasswordKeyUp(event:any){
    this.password = event.target.value;
    
  }
  onCurrencyChoice(event:any){
    this.currencyChoice = event.target.value;
    
  }
  onMobOperatorChoice(event:any){
    this.mobOperatorChoice = event.target.value;
    
  }
  onCountryChoice(event:any) {
    this.countrycode = event.target.value;
    console.log('Country Info:')
    console.log(this.countrycode);
    
  }
  onCurrency(event:any) {
    this.currencyChoice = event.target.value;
    console.log('Currency Info:')
    console.log(this.currencyChoice);
    
  }
  public currency() {
    this.http.get('https://api-staging.videyo.tv/manage/listCurrencies',{
    })
    .subscribe(
      data => {
         this.currencyType = data['currency'];
         console.log('Currency');
         console.log(this.currencyType);
      },
      error => {
        console.log('current fail');
        

      }
  );
  }
  public operator() {
    this.http.get('https://api-staging.videyo.tv/manage/listMobileOperators',{
    })
    .subscribe(
      data => {
         this.operatorType = data['mobileOperator'];
      console.log(this.operator);
        },
      error => {
        console.log('operator fail');
      }
  );
  }
  public postProfile(){
    this.mobNum = this.mobNum.replace(' ', '').substring(1);
    var tempURL = 'https://api-staging.videyo.tv/manage/register?phoneNumber='+this.mobNum+'&password='+this.password+'&name='+this.name+'&email='+encodeURIComponent(this.email)+'&currencyId='+this.currencyChoice+'&mobileOperatorId='+this.mobOperatorChoice;
   
    this.http.post(tempURL, {}).subscribe(
      data => {
        console.log('profile success');
        this.loaded = false;
        setTimeout(function(){}, 3000);
        this.loginUser();
        
        
      },
      error => {
        console.log('profile fail');
        

      }
    )

  }
  loginUser() {
        var currentUser
        var baseUrl = "https://api-staging.videyo.tv"

        this.http.post(baseUrl + '/api/login', {
            'username': this.mobNum,
            'password': this.password
        }).subscribe(
            res => {
                localStorage.setItem('access_token', (res["access_token"]));
                if (localStorage.getItem('access_token')) {
                  this.router.navigate(['/subscribe/84']);
                }
                else {
                  alert('Sign Up Faied, Please try again later or email info@videyo.tv for help.');
                }
               

            },
            err => {
              alert('Sign Up Faied, Please try again later or email info@videyo.tv for help.');
            }
        );
        return false;
    console.log('Normal Login')
}
signUp() { 
  this.landing = false;
  this.signup = true;
}
submitOTPFake() {
  this.route.params.subscribe(params2 => {
    this.subscriptionStatusId = params2['otpID'];
    this.newUserStatus = params2['needsReset'];
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
    let body = new HttpParams();
    this.http.get('https://staging.videyo.tv/billing/subscribeOtpFake?otp='+this.otp+'&id='+this.subscriptionStatusId, {
      headers: myheader
  })
.subscribe(
  res => {
     if (this.newUserStatus == 'reset') {
     this.router.navigate(['/set-password']);
     }
     else { 
      this.router.navigate(['/']);
     }
  },
  error => {
    if (error.status >= 400 && error.status < 500) { 
      this.ngxSmartModalService.create('myModal1', '').open();
    }
    else if (error.status >= 500) { 
      this.ngxSmartModalService.create('myModal2', '').open();
      
    }
    console.log('ERROR:');
    console.log(error);
  }
);
});
}
  subscribeOTP:any;
  subscriptionStatusId:any;
  otp: string = '';
  
  onOTPKeyUp(event: any) {
    this.otp = event.target.value;
  }

  ngOnInit() {
    
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.loaded = true;
    }, 1500);
  }

}
